import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Logger } from '@core/logger';
import { concat, interval, of } from 'rxjs';
import { envTypes } from 'src/environments/env.types';
import { environment } from 'src/environments/environment';
import { SetItem } from '@core/util/local-storage';
import { switchMap } from 'rxjs/operators';

const versionRefreshKey = 'versionRefresh';

export interface AppData {
	version: string;
}

@Injectable({
	providedIn: 'root',
})
export class VersionUpateService {
	constructor(private updates: SwUpdate) {
		if (
			environment.env === envTypes.PRODUCTION ||
			environment.env === envTypes.STAGING
		) {
			this.injectService();
		}
	}

	async injectService() {
		console.log(`VersionUpateService: Service started`);

		// Do first check on first load then
		// poll for updates every 5 minutes
		// Until a new version is detected
		concat(
			of(0), // First check immediately
			interval(5 * 60 * 1000), // Then every 5 minutes
		)
			.pipe(
				switchMap(() => {
					return this.updates.checkForUpdate();
				}),
			)
			.subscribe();

		// Listen for updates
		this.updates.versionUpdates.subscribe((evt) => {
			if (evt.type === 'NO_NEW_VERSION_DETECTED') {
				Logger.info('No version update detected');
			}

			if (evt.type === 'VERSION_READY') {
				Logger.info('Version ready setting storage');
				SetItem(versionRefreshKey, evt);
			}

			Logger.info('VersionUpateService: Version update event', evt);
		});
	}
}
